import {
  SegmentedRadioGroup,
  type SegmentedRadioGroupProps,
  Field,
} from '@sapphire-react/core';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';

import { FormFieldProps } from '../types';

type Props = Omit<SegmentedRadioGroupProps, 'value' | 'name'> & {
  name: string;
  onChange?: (name: string) => void;
} & FormFieldProps & {
    children: ReactNode;
  };

export function SegmentedRadioGroupField(props: Props) {
  const { control, name, defaultValue, children, rules, onChange, ...rest } =
    props;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || undefined}
      render={({ field: { ref: _ref, ...field }, fieldState: { error } }) => (
        <>
          <SegmentedRadioGroup
            {...field}
            {...rest}
            id={field.name}
            value={field.value}
            data-test-id={`${name}-radio-group`}
            onChange={(value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            align={'stretch'}
          >
            {children}
          </SegmentedRadioGroup>
          {!!error?.message && typeof error?.message !== 'boolean' && (
            <Field.Footer>
              <Field.Note variant={'error'}>{error?.message}</Field.Note>
            </Field.Footer>
          )}
        </>
      )}
    />
  );
}

